import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import {
  getStatusStyles,
  PERMISSIONS,
  STATIC_KEYS,
} from "src/constants/constants";
import { AlertService } from "src/services/alert.service";
import { CommonService } from "src/services/common.service";

export interface TableColumnList {
  name: string;
  key: string;
  width: string;
  type:
    | "text"
    | "image"
    | "toggle"
    | "input"
    | "dropdown"
    | "link"
    | "iconButton"
    | "multipleTexts"
    | "status"
    | "iconButton2";
  image?: boolean;
  event?: string;
  style?: Record<string, string>;
  spanStyle?: Record<string, string>;
  iconUrl?: string;
  buttonIconUrl?: string;
  avatarKey?: string;
  iconHeight?: string;
  iconWidth?: string;
  noFilterIcon?: boolean;
  showAfterText?: boolean;
  isStatus?: boolean;
}

@Component({
  selector: "table-component",
  templateUrl: "./table.component.html",
  styleUrls: ["./table.component.scss"],
})
export class TableComponent implements OnInit {
  @Input() tableData: any[] = [];
  @Input() columnList: TableColumnList[] = [];
  @Input() isDragDisabled: boolean = true;
  @Input() menuFlag: boolean = false;
  @Input() menuOptions: {
    key: string;
    event: string;
  }[] = [];
  @Input() isLoading: boolean = true;
  @Input() isDialogContent?: boolean = false;
  @Input() getCustomMenuOptions?: (event: any) => any[];
  @Output() actionEvent: EventEmitter<{ action: string; item: any }> =
    new EventEmitter();
  @Output() toggleEvent: EventEmitter<{ event: any; item: any }> =
    new EventEmitter();
  @Output() orderChangeEvent: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() onIconurlclick = new EventEmitter();

  skeletonRows: number = 5;
  statusStyle = getStatusStyles;
  userInfo: any;
  userRole: string = "";
  constructor(
    private alertService: AlertService,
    private commonService: CommonService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.getLoggedInInformation();
  }

  getLoggedInInformation() {
    this.userInfo = this.commonService.getItem(
      STATIC_KEYS.LOGGED_IN_USER_INFO,
      true
    );
  }

  onAction(action: string, item: any): void {
    this.actionEvent.emit({ action, item });
  }

  onToggleChange(event: any, item: any): void {
    this.toggleEvent.emit({ event, item });
  }

  getMergedStyle(item: any, column: any): any {
    const baseStyle = column?.spanStyle || {};

    if (column?.key === "reviewStatus" && item?.reviewStatus) {
      return {
        padding: "4px 8px",
        borderRadius: "8px",
        fontWeight: 600,
        ...this.statusStyle(item.reviewStatus),
        ...baseStyle,
      };
    }

    return baseStyle;
  }
  copyToClipboard(value: string): void {
    // Create a temporary input element to copy the text
    const textArea = document.createElement("textarea");
    textArea.value = value;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    this.alertService.showSnackBar("Copied!");
  }

  handleBrokenImage(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = "assets/images/no-image-preview.png";
  }

  drop(event: CdkDragDrop<any[]>): void {
    moveItemInArray(this.tableData, event.previousIndex, event.currentIndex);
    this.orderChangeEvent.emit(this.tableData);
  }

  getMenuOptions(event: any) {
    const { identifierName = [], permissions: requiredPermissions = [] } =
      this.route.snapshot.data;
    let option: any = [];
    if (this?.getCustomMenuOptions) {
      const dd = this.getCustomMenuOptions(event) || [];
      option = [...dd];
    } else {
      option = [...this.menuOptions];
    }

    if (requiredPermissions.length) {
      option = [
        ...this.getPermissionOptions(
          requiredPermissions,
          identifierName,
          option
        ),
      ];
      // this.getPermissionOptions(requiredPermissions, identifierName, option);
    }

    return option;
  }

  getPermissionOptions(
    requiredPermissions: string[],
    identifierName: string[] = [],
    options: any[] = []
  ): any[] {
    // 1. Sanitize input: ensure it's an array and remove null/undefined items immediately
    let permissionOption: any[] = Array.isArray(options)
      ? options.filter(Boolean)
      : [];

    const userPermissions = this.commonService.getPermissions();

    if (PERMISSIONS.ALL in userPermissions || "r-all" in userPermissions) {
      return permissionOption;
    }

    if (identifierName?.length) {
      identifierName.forEach((identName) => {
        const grantedActions = userPermissions[identName] || [];

        // If the user has some specific actions but not 'all'
        if (grantedActions?.length && !grantedActions.includes("all")) {
          permissionOption = permissionOption.filter((option) => {
            // Extra safety check for the option itself
            if (!option) return false;

            // If no permission key is required for the menu item, show it;
            // otherwise check if user has the specific permission
            return option.permission
              ? grantedActions.includes(option.permission)
              : true;
          });
        }
      });
    }

    // Final pass to ensure no nulls were introduced during filtering logic
    return permissionOption.filter(Boolean);
  }

  onImageAvtrError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = "assets/images/avatar.jpg";
  }

  trackFn(item: { value: string; key: string }) {
    return item.key;
  }

  getStatusMergedStyle(item: any, column: any): any {
    const baseStyle = column?.spanStyle || {};

    if (column?.isStatus && item?.[column.key]) {
      return {
        padding: "4px 8px",
        borderRadius: "8px",
        fontWeight: 600,
        ...this.statusStyle(item[column.key]),
        ...baseStyle,
      };
    }

    return baseStyle;
  }
}
